<script lang="ts">
    import AomdMap from "../AomdMap.svelte"

    let testData: SectorMap = {
        ships: [{
            id: 1,
            callsign: "USS",
            name: "コバヤシマル",
            coordinate_x: 3,
            coordinate_y: 5,
            picture: null
        },{
            id: 2,
            callsign: "AdS-SV",
            name: "いのら",
            coordinate_x: 4,
            coordinate_y: 8,
            picture: null
        },{
            id: 3,
            callsign: "NsR",
            name: "エシェル",
            coordinate_x: 12,
            coordinate_y: 12,
            picture: null
        },{
            id: 3,
            callsign: "NsR",
            name: "晴上",
            coordinate_x: 12,
            coordinate_y: 13,
            picture: null
        },{
            id: 4,
            callsign: "NsR",
            name: "プレリオン",
            coordinate_x: 13,
            coordinate_y: 12,
            picture: null
        }],
        stations: [{
            id: 1,
            name: "観測ステーション",
            coordinate_x: 8,
            coordinate_y: 8
        },{
            id: 2,
            name: "交易ステーション",
            coordinate_x: 4,
            coordinate_y: 19
        }],
        fairway: [{
            sector_id_alpha: 1,
            sector_id_beta: 2,
            move_range_alpha: 2,
            central_coordinate_alpha_x: 18,
            central_coordinate_alpha_y: 18,
            move_range_beta: 2,
            central_coordinate_beta_x: 2,
            central_coordinate_beta_y: 2
        }]
    };
</script>

<AomdMap sectorId="1" map={testData}/>